<template>
  <div class="jishuzixun">
    <div class="cont_service wow bounceInUp">
      <div class="cont_title">主要包含服务</div>
      <div class="s_main">
        <div class="m_left">
          <img
            src="../../assets/img/productService/jishuzixun/poster.png"
            alt="专项统计与统计数据咨询"
          />
        </div>
        <div class="m_right">
          <div class="m_title">
            <div class="title_zh">技术咨询</div>
            <div class="title_en">TECHNICAL CONSULTING</div>
          </div>
          <ul class="serviceList">
            <li class="s_item s_item1">调查技术咨询</li>
            <li class="s_item s_item2">统计技术咨询</li>
            <li class="s_item s_item3">数据处理电脑编程</li>
            <li class="s_item s_item1">调查数据编码录入</li>
            <li class="s_item s_item2">代理统计分析</li>
            <li class="s_item s_item3">市场营销策划顾问</li>
            <li class="s_item s_item1">统计数据评估</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cont_case wow bounceInUp">
      <div class="cont_title">服务案例</div>
      <div class="c_main">
        <div class="m_info">
          <p class="info_text">
            近年来为广东省工商业联合会（总商会）、广州市社会科学院、中国人民政治协商会议广州市委员会等多个部门机构提供过统计技术咨询、数据处理电脑编程及调查数据编码录入等服务。
          </p>
          <div class="caseBox">
            <div class="item_case">
              <div class="case_img">
                <img
                  src="../../assets/img/productService/jishuzixun/logo_gsylhh.png"
                  alt="广东省工商业联合会"
                />
              </div>
              <p>广东省工商业联合会</p>
            </div>
            <div class="item_case">
              <div class="case_img">
                <img
                  src="../../assets/img/productService/jishuzixun/logo_shkxy.png"
                  alt="广州市社会科学院"
                />
              </div>
              <p>广州市社会科学院</p>
            </div>
            <div class="item_case">
              <div class="case_img">
                <img
                  src="../../assets/img/productService/jishuzixun/logo_zx.png"
                  alt="广州市政协"
                />
              </div>
              <p>广州市政协</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "jishuzixun",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.jishuzixun {
  .cont_title {
    font-size: 18px;
    color: #333333;
    padding: 0 0 0 6px;
    border-left: 6px solid #406cdd;
  }
  .cont_service {
    width: $themeMinWidth;
    margin: 0 auto;
    .s_main {
      display: flex;
      justify-content: space-between;
      padding: 30px 0 0 0;
      .m_left {
        width: 563px;
        height: 234px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .m_right {
        width: 580px;
        .m_title {
          .title_zh {
            font-size: 20px;
            font-weight: bold;
            color: #333333;
          }
          .title_en {
            font-size: 16px;
            color: #999999;
            line-height: 24px;
          }
        }
        .serviceList {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .s_item {
            font-size: 16px;
            color: #333333;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #ffffff;
            border: solid 1px #e5e5e5;
            margin: 30px 0 0 0;
            &.s_item1 {
              width: 176px;
            }
            &.s_item2 {
              width: 156px;
            }
            &.s_item3 {
              width: 186px;
            }
          }
        }
      }
    }
  }
  .cont_case {
    padding: 30px 0 0 0;
    .cont_title {
      width: $themeMinWidth;
      margin: 0 auto;
      box-sizing: border-box;
    }
    .c_main {
      // background: url("../../assets/img/index/cont_Company.png") center
      //   no-repeat;
      // background-size: cover;
      margin: 30px 0 0 0;
      .m_info {
        width: $themeMinWidth;
        margin: 0 auto;
        padding: 20px 0;
        display: flex;
        .info_text {
          width: 528px;
          box-sizing: border-box;
          padding: 26px 20px;
          margin: 0 30px 0 0;
          text-indent: 32px;
          font-size: 16px;
          color: #666666;
          line-height: 30px;
          text-align: justify;
          background-color: #ffffff;
          box-shadow: 2px 3px 21px 0px rgba(22, 22, 22, 0.05);
          border: solid 1px #ffffff;
        }
        .caseBox {
          display: flex;
          width: 610px;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          .item_case {
            width: 176px;
            height: 129px;
            background-color: #ffffff;
            box-shadow: 2px 3px 21px 0px rgba(22, 22, 22, 0.05);
            border-radius: 10px;
            .case_img {
              height: 60px;
              padding: 20px 0 0 0;
              img {
                display: block;
                width: 72px;
                height: 52px;
                object-fit: contain;
                margin: 0 auto;
              }
            }
            p {
              font-size: 16px;
              line-height: 26px;
              color: #333333;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
